import Video from "@components/cms/Video/Video";

const VideoFile = ({ file }) => {
  return <Video videoSrc={file.src} />;
};

export default VideoFile;
